
    function renderStartupHelp(reason) {
      document.body.innerHTML = `
        <main style="min-height:100vh;display:grid;place-items:center;padding:24px;background:#050814;color:#e8eefc;font-family:Segoe UI,Arial,sans-serif;">
          <section style="max-width:720px;padding:24px 28px;border:1px solid rgba(255,255,255,.14);border-radius:18px;background:rgba(9,15,30,.92);box-shadow:0 20px 80px rgba(0,0,0,.45);">
            <h1 style="margin:0 0 12px;font-size:clamp(28px,4vw,42px);">A projektet Vite-tal kell futtatni</h1>
            <p style="margin:0 0 12px;line-height:1.6;">Ez az alkalmazás a <strong>three</strong> csomagot és Vite build-time funkciókat használ, ezért nem indul el sima <strong>file://</strong> megnyitással vagy tetszőleges egyszerű HTTP szerverről a forrásfájlokat kiszolgálva.</p>
            <p style="margin:0 0 8px;line-height:1.6;">Támogatott indítás fejlesztéshez:</p>
            <pre style="margin:0;padding:14px 16px;border-radius:12px;background:#02050d;color:#9fd3ff;overflow:auto;">npm install
npm run dev</pre>
            <p style="margin:12px 0 8px;line-height:1.6;">Vagy build után a <strong>dist</strong> mappát szolgáld ki:</p>
            <pre style="margin:0;padding:14px 16px;border-radius:12px;background:#02050d;color:#9fd3ff;overflow:auto;">npm run build
npm run preview</pre>
            <p style="margin:12px 0 0;line-height:1.6;opacity:.88;">Részlet: ${reason}</p>
          </section>
        </main>`;
    }

    if (window.location.protocol === "file:") {
      renderStartupHelp("A lap file:// URL-ről lett megnyitva.");
      console.error("A SolarSystem projektet Vite fejlesztői szerverrel vagy a buildelt dist verzióval kell futtatni.");
    } else {
      import("./src/app/main.js").catch((error) => {
        const message = error instanceof Error ? error.message : String(error);
        renderStartupHelp(message);
        console.error("Az alkalmazás indulása meghiúsult. Valószínűleg nem Vite szolgálja ki a projektet.", error);
      });
    }
  